import { render, staticRenderFns } from "./AddEmployeeComponent.vue?vue&type=template&id=1561ef85&"
import script from "./AddEmployeeComponent.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports